import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import RoleService from "services/role.service";

export default function Roles({ color }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const response = await RoleService.getAll();
      setRoles(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des rôles :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (roleName) => {
    if (
      window.confirm(`Voulez-vous vraiment supprimer le rôle ${roleName} ?`)
    ) {
      try {
        await RoleService.delete(roleName);
        fetchRoles();
      } catch (error) {
        console.error("Erreur lors de la suppression :", error);
      }
    }
  };

  return (
  <div className="flex flex-col w-full min-h-screen mt-6 pt-24 items-start justify-start px-4 max-w-7xl mx-auto">
      {/* HEADER DE LA PAGE */}
      <div className="flex flex-col md:flex-row justify-start items-center gap-4 mb-6 w-full">
        <Link
          to="/admin/roles/register"
          className="bg-[#D4AF37] hover:bg-[#b8952e] text-slate-900 font-bold px-6 h-[38px] flex items-center justify-center rounded-lg whitespace-nowrap transition-colors w-full sm:w-auto text-sm"
        >
          <i className="fas fa-plus-circle mr-2"></i> Ajouter un Rôle
        </Link>
      </div>

      {/* TABLE DES RÔLES */}
      <div
        className={`relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-xl overflow-hidden ${
          color === "light" ? "bg-white" : "bg-slate-800 text-white"
        }`}
      >
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr className="bg-[#0F172A] text-white uppercase text-xs font-semibold">
                <th className="px-6 py-4 text-left">Nom du Rôle</th>
                <th className="px-6 py-4 text-left">Permissions</th>
                <th className="px-6 py-4 text-left">Badge</th>
                <th className="px-6 py-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/10">
              {loading ? (
                <tr>
                  <td colSpan="4" className="px-6 py-4 text-center">
                    Chargement...
                  </td>
                </tr>
              ) : (
                roles.map((role) => (
                  <tr
                    key={role.name}
                    className="hover:bg-slate-50/5 transition-colors"
                  >
                    <td className="px-6 py-4 text-sm font-bold">
                      <span className="text-[#D4AF37] mr-2">#</span>
                      {role.name}
                    </td>
                    <td className="px-6 py-4 text-xs text-slate-400">
                      {/* On affiche la liste des noms de permissions, séparés par des virgules */}
                      <div className="max-w-xs truncate italic">
                        {role.permissions && role.permissions.length > 0
                          ? role.permissions.map((p) => p.name).join(", ")
                          : "Aucune permission"}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-md text-[10px] font-black ${
                          role.name === "ROLE_ADMIN"
                            ? "bg-red-500/10 text-red-500 border border-red-500/20"
                            : "bg-blue-500/10 text-blue-500 border border-blue-500/20"
                        }`}
                      >
                        {role.name.split("_")[1]}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <Link
                        to={`/admin/roles/edit/${role.name}`}
                        className="text-slate-400 hover:text-white mx-2 transition-colors"
                      >
                        <i className="fas fa-edit"></i>
                      </Link>

                      <button
                        onClick={() => handleDelete(role.name)}
                        className="text-red-400 hover:text-red-600 mx-2 transition-colors"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

Roles.defaultProps = { color: "dark" };
Roles.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
